export type BucketInterval = 'daily' | 'weekly' | 'monthly'

const LABEL_OPTIONS: Record<BucketInterval, Intl.DateTimeFormatOptions> = {
  daily: { day: '2-digit', month: 'short' },
  weekly: { day: '2-digit', month: 'short' },
  monthly: { month: 'short', year: '2-digit' },
}

export function formatBucketLabel(
  date: string,
  interval: BucketInterval,
  locale: string,
): string {
  const [year, month, day] = date.split('-').map(Number)
  return new Intl.DateTimeFormat(locale, {
    ...LABEL_OPTIONS[interval],
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(year, month - 1, day)))
}
